const rLicensePlate: any = {
  car: /^[A-Z]{3}\d{3}$|^[A-Z]{2}\d{3}[A-Z]{2}$/,
  trailer: /^\d{3}[A-Z]{3}\d{3}$|^\d{3}[A-Z]{2}\d{3}[A-Z]{2}$/,
  motorcycle: /^\d{3}[A-Z]{3}$|^[A-Z]{1}\d{3}[A-Z]{3}$/,
};

export default function VehicleDetailsValidations(
  values: any,
  defaultValues: any,
  extraInfo: any
) {
  //   Patente: La patente debe validar como formato válido > AAA111 AA111BB (auto)
  //               > Para dominio de Tipo de vehículo trailer > 101AAA111 101AA111BB
  //               > Para dominio de Tipo de vehículo moto > A111BB 111BB
  // Chasis : Los dígitos ingresados no pueden ser inferiores a 10 ni superiores a 21.
  // Motor  : Los dígitos ingresados no pueden ser inferiores a 6 ni superiores a 21.
  let errors: any = {};
  let countOfChanges = 0;

  if (!values.license_plate) {
    errors.license_plate = 'Campo Requerido';
  }

  if (!values.engine_number) {
    errors.engine_number = 'Campo Requerido';
  }

  if (!values.chassis_number) {
    errors.chassis_number = 'Campo Requerido';
  }

  if (
    !rLicensePlate[extraInfo.grouped_vehicle_type].test(values.license_plate) &&
    values.license_plate !== defaultValues.license_plate
  ) {
    errors.license_plate = 'La patente ingresada es incorrecta';
  }

  if (
    !(
      values.chassis_number.length >= 10 && values.chassis_number.length <= 21
    ) &&
    values.chassis_number !== defaultValues.chassis_number
  ) {
    errors.chassis_number = 'El N° de chasis es incorrecto';
  }

  if (
    !(values.engine_number.length >= 6 && values.engine_number.length <= 21) &&
    values.engine_number !== defaultValues.engine_number
  ) {
    errors.engine_number = 'El N° de motor es incorrecto';
  }

  for (const key in values) {
    if (Object.prototype.hasOwnProperty.call(values, key)) {
      if (values[key] !== defaultValues[key]) {
        countOfChanges++;
      }
    }
  }
  if (countOfChanges > 2) {
    errors.limitChanges = '* Solo puede realizar hasta 2 cambios por solicitud';
  }

  return errors;
}
